<template>
    <div class="main-content">
        <div class="union-info">
            <h3>{{unionName}}</h3>
            <p>请选择院区/体检类型</p>
        </div>
        <div class="hosp-list">
            <div v-for="(hosp,i) in hospitals" :key="hosp.hosp_id" class="hosp-card" @click="onSelected(hosp)">
                <div class="hosp-logo">
                    <img :src="hosp.img_sm_url" />
                </div>
                <div class="hosp-info">
                    <div class="hosp-name">
                        {{hosp.hosp_name}}
                        <span class="hosp-state" v-if="hosp.enable">可预约</span>
                        <span class="hosp-state hosp-state--disble" v-else>建设中</span>
                    </div>
                    <div class="hosp-addr">{{hosp.address}}</div>

                    <div class="hosp-remark">{{hosp.remark}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
    .union-info {
        padding: 16px;

        h3 {
            font-size: 20px;
            margin-bottom: 8px;
        }
    }

    .hosp-list {

        .hosp-card {
            background: #fff;
            border: 1px solid rgba(215, 215, 215, 0.45);
            box-shadow: 3px 3px 8px rgba(215, 215, 215, 0.35);
            display: flex;
            margin-bottom: 20px;
            cursor: pointer;

            .hosp-logo {
                margin: auto 0;
                text-align: center;

                img {
                    width: 110px;
                    margin: 12px 0 12px 12px;
                    border-radius: 5px;
                }
            }

            .hosp-info {
                flex: 1;
                padding: 12px;

                .hosp-name {
                    font-size: 17px;
                    margin-bottom: 8px;
                }

                .hosp-state {
                    border-radius: 3px;
                    padding: 2px 4px;
                    font-size: 12px;
                    color: #3369ff;
                    border: 1px solid #3369ff;
                    float: right;
                }

                .hosp-state--disble {
                    color: #7c7c7c;
                    border: 1px solid #7c7c7c;
                }

                .hosp-addr {
                    font-size: 13px;
                    color: #a1a1a1;
                    padding-bottom: 6px;
                }

                .hosp-remark {
                    font-size: 14px;
                    color: #676871;
                    line-height: 18px;
                }
            }
        }
    }
</style>

<script>
    import {
        getUnion
    } from "@/api/hospital";
    export default {
        data() {
            return {
                hospitals: [],
            };
        },
        mounted() {
            var unionCode = this.$route.query.code;
            var hideHospId = this.$route.query.hide;
            if (!unionCode || unionCode == '') {
                this.$toast.fail("code参数错误");
                return
            }
            getUnion(unionCode).then(res => {
                this.hospitals = res.data;
                //判断隐藏哪些机构
                if (hideHospId && hideHospId.length > 0) {
                    var ids = hideHospId.split(',');
                    if (ids.length > 0) {
                        this.hospitals = this.hospitals.filter(hosp => {
                            return ids.findIndex(id => id == hosp.hosp_id) < 0
                        })
                    }
                }
            })
        },
        computed: {
            unionName() {
                if (this.hospitals && this.hospitals.length > 0) {
                    return this.hospitals[0].union_name;
                } else {
                    return ""
                }
            }
        },
        methods: {
            getAvatar(sex) {
                switch (sex) {
                    case 1:
                        return require("@/assets/images/avatar-male.png");
                        break;
                    case 2:
                        return require("@/assets/images/avatar-female.png");
                        break;
                    default:
                        return require("@/assets/images/avatar-male.png");
                        break;
                }
            },
            onSelected(hospital) {
                console.log(hospital);
                if (hospital.link && hospital.link != "" && hospital.enable)
                    window.location.href = hospital.link;
            },
            editProfile(profile) {
                this.$router.push({
                    path: '/user/editProfile',
                    query: {
                        pid: profile.id
                    }
                });
            }
        }
    };
</script>